export default {
    getUserHasOrders(state) {
        return state.userHasOrders;
    },
    getHost(state) {
        return state.host;
    },
    getSiteHost(state) {
        return state.siteHost;
    },
    getMessage: (state) => (key) => {
        let translate = state.messages[key];
        let res = key;
        if (translate) {
            if (translate[state.currentLanguge]) {
                res = translate[state.currentLanguge];
            }
        }
        return res;
    },
    getLocale(state) {
        if (state.currentCountry && state.currentLanguge) {
            return {
                country: state.currentCountry,
                lang: state.currentLanguge,
                currency: state.countries[state.currentCountry.toUpperCase()],
            };
        }
        return {
            country: "RU",
            lang: "RU",
            currency: {
                currency: "₽",
                currencyCode: "RUB",
                dativeCaseName: "России",
                fullName: "Россия",
                genitiveCaseName: "России",
                language: "ru",
                phone_code: 7,
            },
        };
    },
    getLangs(state) {
        return state.langs;
    },
    getLang(state) {
        return state.currentLanguge || "RU";
    },
    getCountries(state) {
        return state.countries;
    },
    getCurrentCountry(state) {
        return state.currentCountry || "RU";
    },
    getCurrentCountryPhoneCode(state) {
        if (state.countries) {
            return "+" + state.countries[state.currentCountry].phone_code;
        }
        return "+7";
    },
    getMinimumOrderPrice(state, getters) {
        return Math.ceil(
            (state.minimumOrderPriceCoefficient * (state.minimumOrderPrice[getters.getCurrencyCode]?.quant || 1)) /
                state.minimumOrderPrice[getters.getCurrencyCode]?.rate || 1
        );
    },
    getShowContactPhone(state) {
        return state.showContactPhone;
    },
    getContactPhone(state, getters) {
        if (getters.getCurrentCountry == "RU") return "+7 (499) 229-11-11";
        return "+7 499 229-11-11";
    },
    getCurrency(state, getters) {
        if (getters.getLocale) {
            return getters.getLocale.currency.currency || getters.getLocale.currency.currencyCode;
        } else {
            return "₽";
        }
    },
    getCurrencyCode(state, getters) {
        if (getters.getLocale) {
            return getters.getLocale.currency.currencyCode;
        } else {
            return "RUB";
        }
    },
    getStatusPpsCourier(state) {
        return state.statusPpsCourier;
    },
    getStatusPpsCourierPreorderPayment(state) {
        return state.statusPpsCourierPreorderPayment;
    },
    getMainMenu(state) {
        return state.mainMenu;
    },
    getBanner(state) {
        return state.banner;
    },
    getProductBlocks(state) {
        return state.productBlocks;
    },
    getProductBlocksForMain(state) {
        return state.productBlocks.filter(
            (b) =>
                typeof b.placement === "undefined" ||
                b.placement.some((p) => [state.bannerPlacement.EVERYWERE, state.bannerPlacement.MAIN].includes(p))
        );
    },
    getProductBlocksForWomanCategory(state) {
        return state.productBlocks.filter(
            (b) =>
                Array.isArray(b.placement) &&
                b.placement.some((p) =>
                    [
                        state.bannerPlacement.EVERYWERE,
                        state.bannerPlacement.CATEGORY,
                        state.bannerPlacement.WOMAN_CATEGORY,
                    ].includes(p)
                )
        );
    },
    getProductBlocksForManCategory(state) {
        return state.productBlocks.filter(
            (b) =>
                Array.isArray(b.placement) &&
                b.placement.some((p) =>
                    [
                        state.bannerPlacement.EVERYWERE,
                        state.bannerPlacement.CATEGORY,
                        state.bannerPlacement.MAN_CATEGORY,
                    ].includes(p)
                )
        );
    },
    getProductBlocksForWomanCatalog(state) {
        return state.productBlocks.filter(
            (b) =>
                Array.isArray(b.placement) &&
                b.placement.some((p) =>
                    [state.bannerPlacement.EVERYWERE, state.bannerPlacement.WOMAN_CATALOG].includes(p)
                )
        );
    },
    getProductBlocksForManCatalog(state) {
        return state.productBlocks.filter(
            (b) =>
                Array.isArray(b.placement) &&
                b.placement.some((p) =>
                    [state.bannerPlacement.EVERYWERE, state.bannerPlacement.MAN_CATALOG].includes(p)
                )
        );
    },
};
